import type { FaireProductEntity } from "../../entity_types/product";

export const p_74jb4dfpzt: FaireProductEntity = {
  token: "p_74jb4dfpzt",
  type: "product",
  name: "Stainless Steel D-chain necklace - gold",
  brandToken: "b_9qv2bhnwv6",
  brandName: "Bazou",
  imageUrl:
    "https://cdn.faire.com/fastly/d97c92e2b735db6c6d378152c9b2f468a51175c656642e02298bdee49f7bb1e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1338ad3c2f6a98cf1995c08768791e39c205873fd69fd06ddedd4517a782429a.jpeg",
    "https://cdn.faire.com/fastly/4645000b3dc1d9c08929eb8a4dd2fed04c50f1d6249ac9fc81e3649bbb4b7971.jpeg",
  ],
  priceDollars: 8.18,
  description:
    "Material: Stainless Steel (Stainless steel, so does not discolour!)\nDimensions: The necklace has a total length of 44 cm, but can be worn in several positions due to the chains",
  tags: [],
  msrpDollars: 19.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:08.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
